/* 🤖 this file was generated by svg-to-ts */
export const iconSafepalwallet: {
  name: 'safepalwallet';
  data: string;
} = {
  name: 'safepalwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0M6.49 13.44l6.73-6.75c.43-.43 1.01-.67 1.62-.67h11.18l-4.79 4.81h-9.27c-.58 0-1.05.47-1.05 1.06v7.83L6.5 15.3c-.25-.26-.38-.59-.38-.93s.13-.67.38-.93zm19.15 5.12-6.73 6.75c-.43.43-1.01.67-1.62.67H6.11l4.79-4.81h9.27c.58 0 1.06-.47 1.06-1.06v-7.83l4.41 4.42c.26.26.38.59.38.93s-.13.67-.38.93"/></svg>`,
};
